// Scroll To

window.SiteReady(($) => {
  console.log('Init: Scroll To');

  let $ScrollItems = $('.js-scroll_to, a[href*="#"]').not('.js-no_scroll_to, a[href*="#spu-"]');
  $ScrollItems.on('click', onScrollTo);

  function onScrollTo(e) {
    let $target = $(e.delegateTarget);
    let id = $target[0].hash;
    let $to = $(id);

    if (
      e.target.pathname !== window.location.pathname ||
      e.target.hostname !== window.location.hostname ||
      e.target.protocol !== window.location.protocol ||
      e.target.search !== window.location.search
    ) {
      return;
    }

    if ($to.length) {
      e.preventDefault();
      e.stopPropagation();

      scrollToElement(id);

      $(document).trigger('scroll_to');
    }
  }

  function scrollToElement(id) {
    let $to = $(id);

    if ($to.length) {
      let offset = $to.offset();
      let margin = parseInt($to.css('scroll-margin-top'), 10);

      scrollToPosition(offset.top - margin);
    }
  }

  function scrollToPosition(top) {
    let offset = 0;

    $('html, body').animate({ scrollTop: top - offset });
  }

  //

  window.scrollToElement = scrollToElement;
  window.scrollToPosition = scrollToPosition;

});